import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { FooterQuestionsStyled } from './FooterQuestionsStyled';
import { getFooterBlockAPI } from 'aster-foundation/core/epharmacy/Footer/api/api';
import { errorHandling } from '@common/Utility/common-utils';

const DisplayFooterQuestions = (props) => {

  const { data } = props;
  const { questionBlock, answerBlock } = data;
  const answerRef = useRef(null);
  const queRef = useRef(null);

  useEffect(() => {
    if (answerRef == null) {
      return '';
    }
    if (answerRef && answerRef.current) answerRef.current.innerHTML = answerBlock?.substring(0, 2500) || '';
  }, [answerRef, answerBlock]);

  useEffect(() => {
    if (queRef == null) {
      return '';
    }
    if (queRef && queRef.current) queRef.current.innerHTML = questionBlock || '';

  }, [queRef, questionBlock]);

  return (
    <div className="questionBox">
      <h1 className="question" ref={queRef}></h1>
      <div className="answer" ref={answerRef} />
    </div>
  );
};


const FooterQuestions = (props) => {
  const { footerId, footerType } = props;
  const [footerBlockData, setFooterBlockData] = useState([]);

  useEffect(() => {
    const param = {
      footerId: footerId,
      footerType: footerType
    };
    getFooterBlockAPI(param)
      .then(response => {
        if (response?.data) {
          setFooterBlockData(response?.data?.q_and_a_block);
        }
      })
      .catch(error => {
        errorHandling(error);
      });
  }, [footerId]);

  return (
    <FooterQuestionsStyled>
      <Container>
        {footerBlockData?.map((response, i) => {
          return (
            <DisplayFooterQuestions data={response} key={i} />
          );
        })}
      </Container>
    </FooterQuestionsStyled>
  );
};

FooterQuestions.propTypes = {
  footerId: PropTypes.number,
  footerType: PropTypes.string,
};

DisplayFooterQuestions.propTypes = {
  data: PropTypes.object,
};

export default FooterQuestions;
